async function getCoordinates(pincode) {

    try {

        if (typeof pincode === 'object' && pincode !== null) {

            let coords = pincode.coords;
            const {lat, lng} = coords;
            return [lat, lng];
        }else{
            const apiKey = "AIzaSyCkHE10Hz24o46KFEDauQIiFwI7Kse49FM";
            const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${pincode}&key=${apiKey}`;
            const response = await fetch(url);
            const data = await response.json();
    
            if (data.status === "OK") {
                const location = data.results[0].geometry.location;
                return [location.lat, location.lng];
            } else {
                console.error("Geocoding API Error:", data.status);
                return null;
            }
        }

    } catch (error) {
        console.error("Error occurred while fetching data:", error);
        return null;
    }
}

// Function to calculate distance between two sets of coordinates (latitude and longitude) using Haversine formula
function calculateDistance(lat1, lon1, lat2, lon2) {
    const earthRadius = 6371; // Earth's radius in km
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c;

    return distance; // Distance in kilometers
}

// Function to convert degrees to radians
function toRadians(degrees) {
    return degrees * Math.PI / 180;
}

// Your array of locations with their corresponding names and pincodes
const locations = storesData.locations ? storesData.locations : [];

function stripHtmlTags(htmlString) {
    // Remove HTML tags using a regular expression
    return htmlString.replace(/<[^>]*>?/gm, ' ');
}
// Function to check if each location is nearby the user's pincode
async function checkNearbyLocations(userPincode) {
    const userCoordinates = await getCoordinates(userPincode);
    let storeHtml = "";
    if (userCoordinates !== null) {
        let filteredLocations = [];
        for (const location of locations) {
            const locationCoordinates = await getCoordinates(location);
            if (locationCoordinates !== null) {
                const distance = calculateDistance(userCoordinates[0], userCoordinates[1], locationCoordinates[0], locationCoordinates[1]);
                // Assuming a threshold of 10 kilometers for nearby
                if (distance <= 30) {
                    filteredLocations.push({ ...location, distance });
                }
            }
        }
        // filteredLocations.sort((a, b) => a.distance - b.distance);
        filteredLocations.sort((a, b) => {
            // Define title priorities
            const getTitlePriority = (title) => {
                if (title.toLowerCase() === 'sleepycat sleep studio') return 1;
                if (title.toLowerCase() === 'springwel') return 2;
                return 3;
            };
             
            // Calculate priorities for comparison
            const priorityA = getTitlePriority(a.title.toLowerCase());
            const priorityB = getTitlePriority(b.title.toLowerCase());
        
            // Sort by title priority first
            if (priorityA !== priorityB) {
                return priorityA - priorityB;
            }

            // return a.distance - b.distance; 
        });

        // filteredLocations.sort((a, b) => {
        //     const titleA = a.title.toLowerCase();
        //     const titleB = b.title.toLowerCase();
        
        //     const containsSpringwelA = titleA.includes('springwel');
        //     const containsSpringwelB = titleB.includes('springwel');
        //     const withinDistanceA = a.distance <= 30;
        //     const withinDistanceB = b.distance <= 30;
        
        //     if (containsSpringwelA !== containsSpringwelB) {
        //         // Prioritize "Springwel" locations
        //         return containsSpringwelA ? -1 : 1;
        //     } else if (containsSpringwelA && withinDistanceA !== withinDistanceB) {
        //         // Prioritize within distance "Springwel" locations
        //         return withinDistanceA ? -1 : 1;
        //     } else {
        //         // Sort by distance
        //         return a.distance - b.distance;
        //     }
        // });

        let maxStores = 99;
        let count = 0;
        filteredLocations.forEach(store => {
            if(count > maxStores){return false;}
            let addressString = "";            
            // if (store.address2) {
            //     addressString += store.address2 + ', ';
            // }

            addressString = (store.address2) ? store.address2 : store.address1;
            // <a href="#" class="storeViewDetails" onClick="getPlaceDetails(event, '${store.placeId}')">View Store Timings</a>
            storeHtml += `<div class='store-pdp-wrapper'>
            <div class="flexbox justify-content-between align-content-center">
                <span class='store-name'>${store.title}</span>
                <a class="getShareLink test d-inline-block align-self-start" data-gtm_attr="${store.title}" href="https://api.whatsapp.com/send?text=Looking for better sleep? Head to the ${stripHtmlTags(store.title)} 🚘.%0a${encodeURIComponent(store.shareableURL)}" target="_blank" data-action="share/whatsapp/share" title="Share this location on Google Maps">
                    <span>Share</span>
                    <span class="ms-1 fa fa-share-alt"></span>
                </a>
            </div>            
            <span class='store-address'>${addressString}</span>
            <span class='store-phone flexbox align-center'>
                <span class='fa fa-phone d-inline-block me-2'></span>
                <a href="tel:${store.phonenum}" style="text-decoration:underline !important;">
                    ${store.phonenum}
                </a>
            </span>
            <div class="details flexbox justify-center align-center">
                <a data-gtm_attr="${store.title}" href="https://www.google.com/maps/dir/?api=1&destination=${addressString}&destination_place_id=${store.placeId}&dir_action=navigate&entry=tl&travelmode=driving" target="_blank" class='getDirectionsLink flexbox align-center justify-center'>
                    Get Directions 
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="193px" height="192.6px" viewBox="0 0 193 192.6" style="fill: #fff;" class="ms-2 d-inline-block" xml:space="preserve">
                        <defs></defs>
                        <g>
                            <path d="M96.5,192.6c-4.1,0.2-7.4-1.2-10.1-3.9c-10.2-10-20.3-20.1-30.5-30.2c-16.3-16.2-32.4-32.6-48.8-48.6 c-8.9-8.7-9.6-17.1-0.9-26C31.9,58,57.7,32.2,83.6,6.5c8.8-8.8,16.8-8.6,25.6,0.2c25.9,25.9,51.9,51.8,77.8,77.8 c8.1,8.1,8.1,15.8,0,23.9c-26.2,26.3-52.6,52.6-78.8,78.9C104.9,190.5,101.3,192.9,96.5,192.6z M61.2,112.2c0,3.8,0,6.8,0,9.8 c0.1,6.6,2.7,9.5,8.2,9.5c5.5,0,8.3-3,8.5-9.4c0.1-5.2-0.1-10.3,0.1-15.5c0.2-5.2,2.3-7.3,7.4-7.4c6.3-0.1,12.7,0.1,19-0.1 c3.5-0.1,4.7,1.5,4.7,4.8c-0.1,4.8,0,9.7,0,14.5c0,2.5-0.1,5.2,2.8,6.4c2.9,1.2,5.5,0.5,7.7-1.8c9.2-9.2,18.4-18.3,27.5-27.6 c3.7-3.8,3.7-6.5-0.1-10.3c-9.1-9.3-18.3-18.4-27.5-27.5c-1.8-1.8-3.8-3.5-6.6-2.4c-3.1,1.2-3.8,4-3.8,7c0,4.8-0.1,9.7,0,14.5 c0.1,3.6-1.4,5.1-5,5.1c-6-0.1-12-0.2-18,0C73.5,82.2,64.5,89,61.7,100C60.7,104.3,61.4,108.6,61.2,112.2z"></path>
                        </g>
                    </svg>
                </a>
            </div>`;
            const eligibleStoreTitles = [
                "SleepyCat Sleep Studio, Lajpat Nagar <span>Now Open</span>",
                "SleepyCat Sleep Studio, Ghitorni",
                "SleepyCat Sleep Studio, Andheri West",
                "SleepyCat Sleep Studio, Indiranagar",
                "SleepyCat Sleep Studio, Basaveshwara",
                "SleepyCat Sleep Studio, Rohini",
                "SleepyCat Sleep Studio, RR Nagar",
                "SleepyCat Sleep Studio, Banaswadi"

            ];
            if (eligibleStoreTitles.some(title => store.title.includes(title))) {
                storeHtml += `
                    <div class="whatsapp-direction-button flexbox justify-center">
                    <a class="bookavisit flexbox align-center justify-center"
                        data-gtm_attr="+store.title+"
                        onclick="openWhatsAppChat(event)" />
                        Book a visit
                        <!-- SVG Icon -->
                        <img id="bundleCategoryListLoader" src="https://cdn.shopify.com/s/files/1/0744/2376/3202/files/whatsapp.png?v=1752732568" style="width: 20px;" class="ms-2">
                    </a>
                    </div>
                `;
            }
        
        storeHtml += `
            <span class='store-timings' data-placeId='${store.placeId}'></span>
        </div>`;   
        count++;
        });
    }
    return storeHtml;
}

function openWhatsAppChat(t) {
    t.preventDefault();
    const a = `https://api.whatsapp.com/send?phone=918588052247&text=${encodeURIComponent("Find nearby store")}`;
    window.open(a, "_blank")
}